<template>
  <div class="container text-center py-4">
    <h2>Usluge</h2>
    <div class="text-justify">
      <c-card v-for="(x, idx) in services" :key="idx"
        :img="x.img ? `services/${x.img}` : null"
        :fa="x.fa"
        :title="x.title"
        :desc="x.desc"
      />
    </div>
  </div>
</template>

<script>
import cCard from "../components/cCard.vue";
export default {
  metaInfo: {
    titleTemplate: "%s | Usluge",
    meta: [
      {
        name: "description",
        content: "IG PROG pruža usluge izrade i održavanja web stranica, aplikacija i računalnih programa.",
      },
    ],
  },
  components: {
    cCard,
  },
  data() {
    return {
      services: [
        { fa: 'laptop-code', title: 'Web aplikacije', desc: 'Izrada web aplikacija prema Vašim specifičnim potrebama korištenjem najnovijih tehnologija.' },
        { fa: 'globe', title: 'Web stranice', desc: 'Izrada moderno dizajniranih i responzivnih web stranica za obrte, tvrtke, apartmane, udruge i sl.' },
        { fa: 'code', title: 'Računalni programi', desc: 'Izrada računalnih programa koji se instaliraju i izvršavaju unutar vašeg operativnog sustava.' },
        { fa: 'search', title: 'SEO optimizacija', desc: 'Optimizacija novih ili postojećih web stranica sa ciljem boljeg prikazvanja na pretraživačkim mrežama.' },
        { fa: 'brain', img: '', title: 'Umjerna inteligencija', desc: 'Implementacija AI rješenja temeljenih na OpenAI modelima za automatizaciju poslovnih procesa, analizu podataka, generiranje sadržaja i slika te razvoj inteligentnih funkcionalnosti unutar postojećih aplikacija.' },
      ],
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/services.vue